import React from 'react';
import { config, api } from './../config';


// Store
import store from '../stores/';

// Dependencies
import moment from 'moment';
import protocolCheck from 'custom-protocol-detection';

export function removeEmptyQueryParams(queryString) {
  if (!queryString) return '';

  // Check if the string starts with '?' and remove it temporarily.
  const hasQuestionMark = queryString.startsWith('?');
  const qs = hasQuestionMark ? queryString.slice(1) : queryString;

  // Split the query string into individual parameters and filter out empty ones.
  const filteredParams = qs.split('&').filter(param => {
    const [, value] = param.split('=');
    // Keep the parameter if there's no '=' (i.e. a flag) or if the value is non-empty.
    return value !== '';
  });

  // Reassemble the query string, preserving the leading '?' if it was present.
  return hasQuestionMark ? '?' + filteredParams.join('&') : filteredParams.join('&');
}


export function feeCurrencyFormatter(amount, currencyCode) {

  let formattedValue = ''

  switch (currencyCode) {
    case 'USD':
      formattedValue = `$${amount}`;
      break;
    case 'CAD':
      formattedValue = `$${amount} ${currencyCode}`
      break;
    default:
      formattedValue = amount;
      break;
  }
  return formattedValue;

}

export function toggleDrawer(e, component, drawerContent) {
  if (e) {
    e.preventDefault();
  }

  component.setState(
    {
      drawerOpen: true,
      drawerContent
    },
    function () {
      const drawer = document.querySelector('.drawer');

      if (drawer) {
        drawer.focus();
      }
    }
  );
}

export function closeDrawer(e, component, closePath, callback) {
  if (e) {
    e.preventDefault();
  }

  document.querySelector('body').classList.remove('drawer-open');

  // Wait for the drawer to slide out before updating the URL
  // or running a function
  setTimeout(function () {
    component.setState({
      drawerOpen: false,
      drawerContent: null
    });

    if (closePath) {
      component.props.routing.push(closePath);
    }

    if (callback) {
      callback();
    }

    // Make sure the close button will show up the next time a drawer opens
    store.SessionStore.hideDrawerClose = false;
  }, 250);

  // Focus the main content
  setTimeout(function () {
    const content = document.querySelector('#main-content');

    if (content) {
      content.focus();
    }
  });
}



export async function openExam(e, exam, userData, examSession, redirect) {
  try{
    const installSid = userData.installSid;
    const examSid = exam.sid;
    const sessionSid = examSession.sid || exam.examSession.sid;

    const url = async () =>  api.get(`/installs/${installSid}/exams/${examSid}/sessions/${sessionSid}/onboard`)
      .then(response => {
        console.log(response)
        return response.data;
      })
      .catch((e) => {
        console.error(e);
      });
      const data = await url();
      console.log(data);


    e.preventDefault();
    if(data.version === "old"){
      const win = window.open(data.redirectUrl);
      const int = setInterval(function () {
        try {
          if (win.location.href && win.location.href === config.sessionEndRedirectUrl) {
            if (redirect) {
              window.location.href = '/';
              clearInterval(int);
            } else {
              window.location.reload();
              clearInterval(int);
            }
          } else if (win === null || win.closed) {
            if (redirect) {
              window.location.href = '/';
              clearInterval(int);
            } else {
              window.location.reload();
              clearInterval(int);
            }
          }
        } catch (e) {}
      }, 1000);
    } else {
      window.location.href = (data.redirectUrl);
    }
   }catch (e) {
    console.warn(e);
  }
}

export async function openExamDirect(installSid, examSid, sessionSid) {
    const url = async () =>  api.get(`/installs/${installSid}/exams/${examSid}/sessions/${sessionSid}/onboard`)
      .then(response => {
        return response.data;
      })
      .catch((e) => {
        console.error(e);
      });
    return await url();

}

export function startPayment(e, component) {
  store.SessionStore.startPayment();
}

export function submitPayment(e, component) {
  store.SessionStore.submitPayment();
}

export function closePayment() {
  setTimeout(function () {
    store.SessionStore.closePayment();
  }, 1000);
}

// Check form validity before submission
export function checkValidity(e, submitFunction, selector, invalidCallback) {
  e.preventDefault();

  let form = null;

  if (selector) {
    form = document.querySelector(selector);
  } else {
    form = e.target;
  }

  form.classList.add('submitted');

  let ie = false;
  let oldMoz = false;
  let safari = false;
  let edge = false;
  let puffin = false;
  let invalidFields = [];

  if (document.querySelector('html').className.indexOf('ie-true') > -1) {
    ie = true;
  }

  if (
    navigator.userAgent.indexOf('Firefox') &&
    parseInt(navigator.userAgent.slice(-4), 10) < 51
  ) {
    oldMoz = true;
  }

  if (navigator.userAgent.indexOf('Safari')) {
    safari = true;
  }

  if (
    navigator.userAgent.indexOf('Edge/14') > -1 ||
    navigator.userAgent.indexOf('Edge/15') > -1 ||
    navigator.userAgent.indexOf('Edge/16') > -1 ||
    navigator.userAgent.indexOf('Edge/17') > -1
  ) {
    edge = true;
  }

  if (navigator.userAgent.indexOf('Puffin') > -1) {
    puffin = true;
  }

  // Old versions of Firefox and IE don’t support one of the invalid selectors used below
  if (!ie && !oldMoz && !edge && !puffin && !safari) {
    invalidFields = form.querySelectorAll(
      'input[required]:invalid, select[required]:invalid, textarea[required]:invalid, input[required][aria-invalid="true"], input[aria-invalid="true"]:not(:placeholder-shown)'
    );
  } else if (edge) {
    invalidFields = form.querySelectorAll(
      'input[required]:invalid, textarea[required]:invalid, input[required][aria-invalid="true"]'
    );
  } else {
    invalidFields = form.querySelectorAll(
      'input[required]:invalid, select[required]:invalid, textarea[required]:invalid, input[required][aria-invalid="true"]'
    );
  }

  if (!invalidFields.length) {
    if (submitFunction) {
      submitFunction(e);
    }

    // Remove error message
    let existingErrorMsg = form.querySelector('.note--error');

    if (existingErrorMsg) {
      existingErrorMsg.parentNode.removeChild(existingErrorMsg);
    }
  } else {
    let existingErrorMsg = form.querySelector('.note--error');

    if (!existingErrorMsg) {
      let errorMsg = document.createElement('SPAN');
      errorMsg.className = 'note note--prominent note--error';
      errorMsg.innerHTML =
        'Sorry, your form contained errors. Please correct the problems before submitting.';
      const fields = form.querySelector('.fields:first-child');
      const fieldsParent = fields.parentNode;
      fieldsParent.insertBefore(errorMsg, fields);
    }

    if (invalidCallback) {
      invalidCallback();
    }

    window.scrollTo(0, 0);
  }
}

// Convert minutes to hours
export function toHours(time, isFirst, textOnly, unabbreviated) {
  let hours = 'hr';
  let minutes = 'min';

  if (unabbreviated) {
    hours = ' hour';
    minutes = ' minute';
  }

  if (time >= 60) {
    if (isFirst) {
      if (textOnly) {
        return time / 60;
      } else {
        return <span>{time / 60}</span>;
      }
    } else {
      if (parseInt(time / 60, 10) > 1 && unabbreviated) {
        hours = ' hours';
      }

      if (unabbreviated) {
        minutes = 'minutes';
      }

      if (textOnly) {
        let minuteText = time % 60 > 0 ? ` ${time % 60} ${minutes}` : '';

        return parseInt(time / 60, 10) + hours + minuteText;
      } else {
        return (
          <span>
            {parseInt(time / 60, 10)} {hours}
            {time % 60 > 0 && ` ${time % 60} ${minutes}`}
          </span>
        );
      }
    }
  } else {
    if (isFirst) {
      if (textOnly) {
        return time;
      } else {
        return <span>{time}</span>;
      }
    } else {
      if (time > 1) {
        minutes = ' minutes';
      }

      if (textOnly) {
        return time + ' ' + minutes;
      } else {
        return (
          <span>
            {time} {minutes}
          </span>
        );
      }
    }
  }
}

// Scroll to top of element
export function toTop(element) {
  if (element) {
    element.scrollTop = 0;
  } else {
    window.scrollTo(0, 0);
  }
}

// Confirm
export function confirm(msg, func) {
  const { SessionStore } = store;
  SessionStore.showConfirm(msg, func);
}

// Prompt
export function promptUser(msg, selectFunc, callback, text) {
  const { SessionStore } = store;
  SessionStore.showPrompt(msg, selectFunc, callback, text);
}

// Round time
export function roundTime(time) {
  if (time && time.minute() !== 0 && time.minute() !== 30) {
    const remainder = 30 - (time.minute() % 30);
    return moment.utc(time).local().add('minutes', remainder).format('HH:mm');
  }

  return moment.utc(time).local().format('HH:mm');
}

// Extract time from date
export function extractTime(time) {
  const { userTimezone } = store.SessionStore;

  if (moment(time, moment.ISO_8601).isValid()) {
    return moment.utc(time).tz(userTimezone).format('HH:mm');
  } else {
    return '';
  }
}

/**
 * Get static map url from google maps API for a given <latitude, longitude> pair
 * @export
 * @param {number} latitude
 * @param {number} longitude
 * @returns {string}
 */
export function getMapUrl(latitude, longitude) {
  return (
    `https://maps.googleapis.com/maps/api/staticmap?center=${latitude},${longitude}` +
    `&zoom=16&scale=2&size=400x250&maptype=roadmap&key=${config.mapsApiKey}` +
    `&format=png&visual_refresh=true&markers=icon:${config.domain}/static/img/marker.png?v=1%7C${latitude},${longitude}`
  );
}

/**
 * Get URL segments
 * @export
 * @param {Component} component
 * @param {number} segment
 */
export function getURLSegment(component, segment) {
  const { pathname } = component.props.routing.location;

  let pathArray = pathname.split('/');

  if (pathArray[0] === '') {
    pathArray.splice(0, 1);
  }

  return pathArray[segment - 1];
}

/**
 * Push the href, usually received from a html element event, to routing history
 * @export
 * @param {string} href
 * @param {Component} component
 */
export function pushHrefToRouting(href, component) {
  // Regex to grab the domain name part of url
  // For example grab 'http://www.url.com/' from 'http://www.url.com/page'
  let domainRegex = /^(?:\/\/|[^\/]+)*\//;

  // Replace the domain name and the '#' with empty string because the react router excludes them from path
  // For example 'http://www.url.com/#/page' becomes '/page'
  let path = href.replace(domainRegex, '').replace('#', '');

  // Push the path to routing if it's not there already
  if (component.props.routing.location.pathname !== path) {
    component.props.routing.push(path);
  }
}

/**
 * Get query params from a string
 * @export
 * @param {name} string
 * @param {url} string
 */
export function getParam(name, url) {
  name = name.replace(/[\[\]]/g, '\\$&');
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
  let results = regex.exec(url);

  if (!results) {
    return null;
  }

  if (!results[2]) {
    return '';
  }

  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

/**
 * Get url path and query from a string
 * @export
 * @param {url} string
 */
export function getPath(url) {
  const parser = document.createElement('a');
  parser.href = url;
  const pathname = parser.pathname;
  const search = parser.search;

  return pathname + search;
}

/**
 * Find ancestor by class
 * @export
 * @param {el} string
 * @param {className} string
 */
export function findAncestor(el, className) {
  while (el.parentNode) {
    el = el.parentNode;

    if (el && el.classList.contains(className)) {
      return el;
    }
  }

  return null;
}

/**
 * Flag portrait oriented image
 * @export
 * @param {e} string
 * @param {src} string
 */
export function flagPortrait(e, src) {
  const img = new Image();
  const imgEl = e.target;
  let width = 0;
  let height = 0;

  img.onload = function () {
    width = img.width;
    height = img.height;

    if (height > width) {
      imgEl.className += ' portrait';
    }
  };

  img.src = src;
}

/**
 * Check if sessionStorage is available
 * @export
 */
export function isLocalStorageSupported() {
  const testKey = 'test';
  const storage = window.sessionStorage;

  try {
    storage.setItem(testKey, '1');
    storage.removeItem(testKey);
    return true;
  } catch (error) {
    return false;
  }
}

/**
 * Get cookie by name
 * @export
 * @param {name} string
 */
export function getCookie(name) {
  const match = document.cookie.match(new RegExp(name + '=([^;]+)'));

  if (match) {
    return match[1];
  }
}

/**
 * Delete cookie by name
 * @export
 * @param {name} string
 */
export function deleteCookie(name) {
  document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

/**
 * Launch VTC session or show download options
 * @export
 * @param {accessCode} string
 */
export function launchVTC(accessCode, failCallback) {
  protocolCheck(`vtc://${accessCode}`, failCallback);

  const docClass = document.querySelector('html').className;

  if (docClass && docClass.indexOf('safari') >= 0) {
    // Protocol check fallback for Safari
    const launchTimeout = setTimeout(function () {
      failCallback();
    }, 200);

    window.addEventListener('blur', function () {
      window.clearTimeout(launchTimeout);
    });

    window.location = `vtc://${accessCode}`;
  }
}

/**
 * Check if input type is supported
 * @export
 * @param {type} string
 */
export function checkInput(type) {
  let input = document.createElement('input');
  input.setAttribute('type', type);
  return input.type === type;
}

/**
 * Check if document is in an iframe
 * @export
 */
export function inIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}

/**
 * Get correct instructor as proctor settings
 * @export
 * @param {instructorAsProctor} array
 * @param {instructorProctorSid} string
 */
export function getInstructorAsProctor(instructorAsProctor, instructorProctorSid) {
  let selectedIAP = null;

  instructorAsProctor.forEach(setting => {
    if (setting.sid === instructorProctorSid) {
      selectedIAP = setting;
    }
  });

  return selectedIAP;
}

/**
 * Format time as 00:00:00
 * @export
 * @param {s} integer
 */
export function formatTime(s) {
  let seconds = Math.floor(s % 60);
  let minutes = Math.floor(s / 60);
  let hours = Math.floor(s / 360 / 60);

  if (seconds < 10) {
    seconds = '0' + seconds;
  }

  if (minutes < 10) {
    minutes = '0' + minutes;
  }

  if (hours < 10) {
    hours = '0' + hours;
  }

  return (
    <span>
      {hours}:{minutes}:{seconds}
    </span>
  );
}

/**
 * Convert object to query string
 * @param {obj} object
 **/
export function convertObjToQuery(obj) {
  const _obj = obj ? obj : {};
  const keys = Object.keys(_obj);

  // Make sure we’re only using keys with a value
  for (let i = 0; i < keys.length; i++) {
    if (!_obj[keys[i]]) {
      keys.splice(i, 1);
      i--;
    }
  }

  // Join all keys and values
  const query = keys
    .map(x => {
      return `${x}=${_obj[x]}`;
    })
    .join('&');

  return keys.length === 0 ? '' : `?${query}`;
}

/**
 * Render proctor approval scope
 * @param {approval} object
 * @param {translation} object
 **/
export function approvalScope(approval, translation) {
  let scope = null;
  let scopeData = null;
  let appliesToData = {};

  Object.keys(approval.appliesTo).forEach(prop => {
    if (approval.appliesTo[prop]) {
      scope = prop;
      scopeData = approval.appliesTo[prop];
    }
  });

  switch (scope) {
    case 'applicationInstall':
      appliesToData.title = translation.appliesTo.installation;
      break;

    case 'course':
      appliesToData.title = translation.appliesTo.course;
      appliesToData.course = scopeData.title;
      break;

    case 'enrollment':
      appliesToData.title = translation.appliesTo.enrollment;
      appliesToData.student = `${scopeData.firstName} ${scopeData.lastName}`;
      appliesToData.course = scopeData.courseTitle;
      break;

    case 'exam':
      appliesToData.title = translation.appliesTo.exam;
      appliesToData.exam = scopeData.title;
      appliesToData.course = scopeData.courseTitle;
      break;

    case 'examSession':
      appliesToData.title = translation.appliesTo.exam_session;
      appliesToData.student = `${approval.requestedByUser.firstName} ${approval.requestedByUser.lastName}`;
      break;

    case 'instructorUser':
      appliesToData.title = translation.appliesTo.instructor;
      appliesToData.instructor = `${scopeData.firstName} ${scopeData.lastName}`;
      break;

    case 'studentUser':
      appliesToData.title = translation.appliesTo.student;
      appliesToData.student = `${scopeData.firstName} ${scopeData.lastName}`;
      break;

    default:
      appliesToData = {};
      break;
  }

  return (
    <div>
      <strong className="table-note">{appliesToData.title}</strong>

      <ul className="table-list">
        {Object.keys(appliesToData).map((key, i) => {
          if (key !== 'title') {
            return <li key={i}>{appliesToData[key]}</li>;
          }

          return null;
        })}
      </ul>
    </div>
  );
}

/**
 * Get proctor approval appliesTo
 * @param {approval} object
 **/
export function appliesTo(approval) {
  let scope = null;

  Object.keys(approval.appliesTo).forEach(prop => {
    if (approval.appliesTo[prop]) {
      scope = prop;
    }
  });

  switch (scope) {
    case 'applicationInstall':
      scope = 'install';
      break;

    case 'examSession':
      scope = 'session';
      break;

    case 'instructorUser':
      scope = 'instructor';
      break;

    case 'studentUser':
      scope = 'student';
      break;

    default:
      break;
  }

  return scope;
}

/**
 * Check if getUserMedia is supported
 */
export async function testGetUserMedia(errorCallback) {
  let supported = true;

  if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
    // Safari on iOS (as of the 11 release) claims to support
    // getUserMedia but chokes the constraints for some reason
    // so we need to test setting up a stream and catch any errors
    const constraints = {
      audio: true,
      video: true
    };

    const details = {
      body: 'In order to use SmarterProctoring Automated, you need to allow webcam and microphone access.',
      link: 'How do I allow access?',
      linkUrl:
        'https://support.google.com/chrome/answer/2693767?co=GENIE.Platform%3DDesktop&hl=en&oco=0'
    };

    async function testMedia() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia(constraints);
        console.log('Got media stream');

        if (stream.getTracks().length === 0) {
          console.error('Got media stream, but no tracks exist!');

          if (errorCallback) {
            errorCallback(details);
          }

          return false;
        }

        stream.getTracks().forEach(track => {
          console.table(track);
        });

        stream.getTracks().forEach(track => track.stop());

        return true;
      } catch (e) {
        console.error(e);
        console.error('Could not get media stream!');

        if (errorCallback) {
          errorCallback(details);
        }

        return false;
      }
    }

    supported = await testMedia();
  } else {
    // Definitely not supported
    supported = false;
  }

  return supported;
}

/*
 * Handle custom keyboard interactions for Switch Inputs.
 * Only for use for elements where className="switch-input" and type="checkbox".
 */
export function handleSwitchInputKeys(e) {
  const keyCode = e.keyCode || e.which;
  const ENTER_KEY = 13;
  const LEFT_ARROW = 37;
  const RIGHT_ARROW = 39;
  const SPACE = 32;

  switch (keyCode) {
    case ENTER_KEY:
      e.preventDefault();
      e.target.click();
      break;

    case LEFT_ARROW:
      e.preventDefault();
      if (e.target.checked) {
        e.target.click();
      }
      break;

    case RIGHT_ARROW:
      e.preventDefault();
      if (!e.target.checked) {
        e.target.click();
      }
      break;

    case SPACE:
      e.preventDefault();
      e.target.click();
      break;

    default:
      break;
  }
}

/**
 * isDescendant - Checks if an element is a descendant of a given parent
 * @export
 * @param {parent} element
 * @param {child} element
 * @return boolean
 */
export function isDescendant(parent, child) {
  let node = child.parentNode;

  while (node !== null) {
    if (node === parent) {
      return true;
    }

    node = node.parentNode;
  }

  return false;
}

/**
 * sumValues - Get the sum of a property value in an array of objects
 * @param {array} array
 * @param {string} key
 */
export function sumValues(array, key) {
  return array.reduce((a, b) => a + (b[key] || 0), 0);
}

/**
 * distanceToTop - Returns an element's distance from the top of the window
 * @export
 * @param {*} element
 */
export function distanceToTop(element) {
  return Math.floor(element.getBoundingClientRect().top);
}

/**
 * atBottom - Returns a boolean, calculates if the window is scrolled to the bottom
 * @export
 */
export function atBottom() {
  return window.innerHeight + window.pageYOffset >= document.body.offsetHeight - 2;
}

/**
 * scrollToTop - Scrolls to the top of an element or window, sets programmatic focus
 * @param {*} element
 */
export function scrollToTop(event, element) {
  const supported = 'scrollBehavior' in document.documentElement.style;
  const prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;
  const allowed = supported && !prefersReducedMotion;

  event.preventDefault();

  if (element) {
    if (allowed) {
      window.scroll({
        top: element.offsetTop - 15,
        left: 0,
        behavior: 'smooth'
      });
      // Callback to set keyboard focus after scrolling is done.
      // Use a buffer of 15 at the top of the element so that it
      // doesn't look cramped.
      const done = setInterval(function () {
        if (distanceToTop(element) === 15 || atBottom()) {
          element.tabIndex = '-1';
          element.focus();
          clearInterval(done);
        }
      }, 100);
    } else {
      element.tabIndex = '-1';
      element.focus();
    }
  } else {
    window.scrollTo(0, 0);
  }
}

/**
 * formatQuery - Takes an object and returns it as URL query parameters
 * @param {object} query
 */
export function formatQuery(query) {
  let queryString = '';

  for (let key in query) {
    // Check to make sure the value in the key is defined
    if (query[key]) {
      if (!queryString) {
        // If this is the first key, add a ?
        queryString += '?';
      } else {
        // Otherwise, add a &
        queryString += '&';
      }

      queryString += `${key}=${query[key]}`;
    }
  }

  return queryString;
}

/**
 * Generate a random GUID
 *
 * @export
 * @function generateGuid
 * @returns {string}
 */
export function generateGuid() {
  let guid = '';

  for (let i = 0; i < 32; i++) {
    if (i === 8 || i === 12 || i === 16 || i === 20) {
      guid += '-';
    }

    const digit = Math.floor(Math.random() * 16)
      .toString(16)
      .toUpperCase();

    guid += digit;
  }

  return guid;
}

/*
 * version Compare
 * @param v1 - version like "17.0.1"
 * @param v2 - version like "16.2.13"
 * @param options
 * @returns {number} - Returns 0 if equal, -1 if v1 < v2 and 1 if v1 > v2
 */
export function versionCompare(v1, v2, options) {
  let lexicographical = options && options.lexicographical,
    zeroExtend = options && options.zeroExtend,
    v1parts = v1.split('.'),
    v2parts = v2.split('.');

  function isValidPart(x) {
    return (lexicographical ? /^\d+[A-Za-z]*$/ : /^\d+$/).test(x);
  }

  if (!v1parts.every(isValidPart) || !v2parts.every(isValidPart)) {
    return NaN;
  }

  if (zeroExtend) {
    while (v1parts.length < v2parts.length) v1parts.push('0');
    while (v2parts.length < v1parts.length) v2parts.push('0');
  }

  if (!lexicographical) {
    v1parts = v1parts.map(Number);
    v2parts = v2parts.map(Number);
  }

  for (let i = 0; i < v1parts.length; ++i) {
    if (v2parts.length === i) {
      return 1;
    }

    if (v1parts[i] === v2parts[i]) {
      continue;
    } else if (v1parts[i] > v2parts[i]) {
      return 1;
    } else {
      return -1;
    }
  }

  if (v1parts.length !== v2parts.length) {
    return -1;
  }

  return 0;
}

/**
 * Names of the operating systems found in the navigator.userAgent
 * @type {{linux: string, chromebook: string, windows: string, mac: string, unknown: string}}
 */
export const OS_USER_AGENT_NAMES = {
  windows: 'Windows',
  mac: 'Mac',
  chromebook: 'CrOS',
  linux: 'Linux',
  unknown: 'Unknown'
};

/**
 * Get OS Name
 * @returns {string}
 */
export function getCurrentOS() {
  let currentOS = OS_USER_AGENT_NAMES.unknown;

  if (navigator.appVersion.indexOf(OS_USER_AGENT_NAMES.windows) !== -1) {
    currentOS = OS_USER_AGENT_NAMES.windows;
  }

  if (navigator.appVersion.indexOf(OS_USER_AGENT_NAMES.mac) !== -1) {
    currentOS = OS_USER_AGENT_NAMES.mac;
  }

  if (navigator.appVersion.indexOf(OS_USER_AGENT_NAMES.chromebook) !== -1) {
    currentOS = OS_USER_AGENT_NAMES.chromebook;
  }

  if (navigator.appVersion.indexOf(OS_USER_AGENT_NAMES.linux) !== -1) {
    currentOS = OS_USER_AGENT_NAMES.linux;
  }

  return currentOS;
}

/**
 * Get the proper download url for the platform
 * @returns {string}
 */
export function getDesktopAppConfigForPlatform() {
  const os = getCurrentOS();
  if (os === OS_USER_AGENT_NAMES.mac) {
    return config.desktopAppInfo.mac;
  } else {
    return config.desktopAppInfo.widows;
  }
}

/**
 * When called it will initiate a download of the file
 * @param uri
 * @param name
 */
export function downloadURI(uri, name) {
  const link = document.createElement('a');
  link.target = '_blank';
  link.download = name;
  link.href = uri;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  link.remove();
}

/**
 * Selector for any HTML element that can receive keyboard focus
 *
 * @exports
 */
export const focusable =
  "a[href]:not([tabindex='-1']),area[href]:not([tabindex='-1']),input:not([disabled]):not([tabindex='-1']),select:not([disabled]):not([tabindex='-1']),textarea:not([disabled]):not([tabindex='-1']),button:not([disabled]):not([tabindex='-1']),iframe:not([tabindex='-1']),[tabindex]:not([tabindex='-1'])";

  /**
 * convert dataurl to file
 * @ param {string} dataurl - dataurl address
 * @ param {string} file name - file name
 */
// Create Blob file from URL

export function dataURLtoFile(dataUrl, fileName){
  var arr = dataUrl.split(','), mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
  while(n--){
      u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], fileName, {type:mime});
}

export function getOverlap(exam, record){
  if(
    moment(exam.examOpenDate).isBetween(record.weekStart, record.weekEnd) ||
    moment(exam.examCloseDate).isBetween(record.weekStart, record.weekEnd) ||
    moment(record.weekStart).isBetween(exam.examOpenDate, exam.examCloseDate) ||
    moment(record.weekEnd).isBetween(exam.examOpenDate, exam.examCloseDate)
    )
    {
      return true;
    }

  else{
    return false;
  }

}



// WEBPACK FOOTER //
// ./src/app/helpers/helpers.js